import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import i18next from './i18n';
import { TonicProvider, Box as Wrapper } from '@tonic-ui/react';

import WebAppAuthContainer from './web-app-auth-container.js';
import { Amplify } from '@aws-amplify/core';
import config from './aws-config.json';
import ErrorHandler from './components/error-handler/error-handler';

const getCognitoEnv = async function () {
  try {
    if (!config.configEndpoints[DEPLOYMENT_TARGET]) {
      return;
    }

    // we need to include credentials as the config endpoint may set
    // a cookie to help ensure transitions are smooth
    const response = await fetch(config.configEndpoints[DEPLOYMENT_TARGET], {
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(
        `An error has occurred retrieving configuration information: ${response.status}`
      );
    }

    return await response.json();
  } catch (e) {
    console.error(`Error fetching Cloud One login configuration: ${e}`);
  }
};

const configureCognito = async function () {
  const cognitoConfig = await getCognitoEnv();

  if (cognitoConfig) {
    Amplify.configure({
      Auth: {
        ...cognitoConfig,
        mandatorySignIn: true,
      },
    });
  } else {
    console.log('Unable to initialize Amplify configuration');
  }
};

// Dark mode support
const colorMode = localStorage.getItem('C1C_THEME_COLOR_MODE') || 'light';

const backgroundColor = {
  light: 'white',
  dark: 'gray:90',
}[colorMode];
const color = {
  light: 'black:primary',
  dark: 'white:primary',
}[colorMode];

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: WebAppAuthContainer,
  errorBoundary(err, info, props) {
    return (
      <TonicProvider colorMode={{ defaultValue: 'light', value: colorMode }}>
        <Wrapper backgroundColor={backgroundColor} color={color} height="100%" overflow="hidden">
          <ErrorHandler />
        </Wrapper>
      </TonicProvider>
    );
  },
});

export async function bootstrap(props) {
  await configureCognito();

  return reactLifecycles.bootstrap(props);
}

export function mount(props) {
  return reactLifecycles.mount(props);
}

export function unmount(props) {
  return reactLifecycles.unmount(props);
}

export function update(props) {
  return reactLifecycles.update(props);
}
